import fm from 'format-message';
import PropTypes from 'prop-types';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import CheckoutHeading from 'templates/CheckoutPage/CheckoutHeading';
import OrderTotal from 'templates/CheckoutPage/OrderTotal';
import Payment from 'templates/CheckoutPage/PaymentSection/Payment';

const PaymentSection = ({
    $style,
    bonusPointsInfo,
    bonusPointsPlaceholder,
    currentCheckoutStep,
    deliveryStep,
    orderLabel,
    paymentStep,
    setCurrentCheckoutStep,
    voucherCodePlaceholder,
    voucherLabel,
}) => {
    const [css] = useStyletron();

    return (
        <div className={css($style)}>
            <CheckoutHeading
                editButtonVisible={currentCheckoutStep > paymentStep}
                label={fm('Payment')}
                onClickEdit={() => setCurrentCheckoutStep(paymentStep)}
            />
            <OrderTotal
                $style={{ display: ['block', null, null, null, null, 'none'] }}
                bonusPointsInfo={bonusPointsInfo}
                bonusPointsPlaceholder={bonusPointsPlaceholder}
                orderLabel={orderLabel}
                showVouchersForm={currentCheckoutStep !== paymentStep}
                voucherCodePlaceholder={voucherCodePlaceholder}
                voucherLabel={voucherLabel}
            />
            <Payment
                $style={{ margin: '24px var(--margin-content) 40px' }}
                checkoutCurrentStep={currentCheckoutStep}
                deliveryStep={deliveryStep}
                paymentStep={paymentStep}
            />
        </div>
    );
};

PaymentSection.propTypes = {
    $style: PropTypes.object,
    bonusPointsInfo: PropTypes.string,
    bonusPointsPlaceholder: PropTypes.string,
    currentCheckoutStep: PropTypes.number,
    deliveryStep: PropTypes.number,
    orderLabel: PropTypes.string,
    paymentStep: PropTypes.number,
    setCurrentCheckoutStep: PropTypes.func,
    voucherCodePlaceholder: PropTypes.string,
    voucherLabel: PropTypes.string,
};

export default PaymentSection;
